import tw from 'tailwind-styled-components';

export const Container = tw.div`max-w-5xl mx-auto p-8 bg-white rounded-lg shadow-lg my-4 lg:my-8 mx-4 lg:mx-auto`;
export const ProgressContainer = tw.div`mb-10`;
export const ProgressFlex = tw.div`flex items-center justify-between`;
export const StepWrapper = tw.div`flex items-center flex-1`;

export const StepCircle = tw.div`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-all duration-300
  ${({ $step, $currentStep }) =>
        $currentStep === $step
            ? 'bg-primary-color text-white'
            : $currentStep > $step
                ? 'bg-green-500 text-white'
                : 'bg-gray-200 text-gray-500'}`;

export const StepLabel = tw.div`text-xs font-medium mt-2 text-center transition-colors duration-300
  ${({ $step, $currentStep }) => $currentStep === $step ? 'text-primary-color' : 'text-gray-500'}`;

export const ProgressLine = tw.div`flex-1 h-1 mx-2 transition-all duration-300
  ${({ $step, $currentStep }) =>
        $currentStep > $step ? 'bg-primary-color' : 'bg-gray-200'}`;

export const FormContainer = tw.div``;
export const SectionTitle = tw.h2`text-2xl font-bold text-gray-800 mb-2`;
export const SectionSubtitle = tw.p`text-sm text-gray-500 mb-6`;
export const GridContainer = tw.div`grid grid-cols-1 md:grid-cols-2 gap-5`;
export const GridThreeContainer = tw.div`grid grid-cols-1 md:grid-cols-3 gap-5`;
export const FullWidthGrid = tw.div`md:col-span-2`;

export const NavigationContainer = tw.div`flex justify-between mt-10 pt-6 border-t border-gray-200`;

export const PrevButton = tw.button`px-6 py-2.5 text-sm font-medium rounded-lg transition-all duration-200
  ${({ $disabled }) =>
        $disabled
            ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
    }`;

export const NextButton = tw.button`px-8 py-2.5 text-sm font-medium text-white rounded-lg transition-all duration-200
  ${({ $loading }) =>
        $loading
            ? 'bg-gray-400 cursor-not-allowed'
            : 'bg-primary-color hover:bg-hover-color'
    }`;
export const SectionDivider = tw.div`mt-6 mb-4`;
export const SubSectionTitle = tw.h3`text-lg font-semibold text-gray-700 mb-2`;